import { render, staticRenderFns } from "./ContentItemsViewInfoCard.vue?vue&type=template&id=160d0919&"
import script from "./ContentItemsViewInfoCard.vue?vue&type=script&lang=js&"
export * from "./ContentItemsViewInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports